import React, { useCallback, useContext, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import HelpRounded from '@material-ui/icons/HelpRounded'
import BFTabs from '../components/Tabs/BFTabs'
import BFTab from '../components/Tabs/BFTab'
import PortfolioTodayCompanyPage from '../containers/PortfolioTodayCompanyPage'
import PortfolioLastWeek from '../containers/PortfolioLastWeek'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { getCookie, setCookieHelper } from '../ultils/cookie'
import { userService } from '../services/users.services'
import { EXPIRED_SECOND } from '../constants/Cookie'
import {
  HOME_PATHNAME,
  PORTFOLIO_HOME_PATHNAME,
  PORTFOLIO_LAST_WEEK_PATHNAME,
  PORTFOLIO_SINGLE_PATHNAME,
} from '../constants/RoutePathName'
import { clearD3Tips } from '../ultils/dataUtil'
import ResponsiveArticle from '../components/ResponsiveArticle'
import PortfolioTooltipModal from '../components/PortfolioTooltipModal'
import { RISK_TYPE } from '../ultils/chart-d3-utils'

const useStyles = makeStyles({
  container: {
    padding: '16px 24px 0px',
    width: '100%',
    boxSizing: 'border-box',
  },
  frame: {
    width: '100%',
    height: 556,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  },
  frameHeader: {
    height: 64,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px',
    background: '#EDF2F7',
    borderStyle: 'solid',
    borderColor: '#DFE4EB',
    borderWidth: '1px 1px 0px 1px',
    boxSizing: 'border-box',
  },
  frameBody: {
    flex: '1 1 auto',
    background: '#FFFFFF',
    borderStyle: 'solid',
    borderColor: '#DFE4EB',
    borderWidth: '0px 1px 1px 1px',
    padding: 24,
    boxSizing: 'border-box',
  },
  toolbar: {
    padding: '20px 55px 0px 55px',
  },
  pageTitle: {
    flex: '1 1 100%',
  },
  filterContainer: {
    width: 200,
  },
  portfolioTable: {
    backgroundColor: '#fff',
    padding: '20px 25px',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
    marginBottom: 35,
  },
  greet: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '22px',
    color: '#181818',
  },
  title: {
    fontWeight: 400,
    fontSize: 20,
    lineHeight: '24.2px',
    color: '#1B3963',
  },
  headPage: {
    height: '60px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logoImg: {
    height: 14,
    width: 14,
  },
  emptyBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '213px 0px',
  },
  emptyIcon: {
    marginBottom: 23,
  },
  noavailableText: {
    fontSize: 24,
    lineHeight: '24px',
    fontWeight: 600,
    color: '#5E5E5E',
  },
  legendWrapper: {
    width: '200px',
  },
  tabsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  riskToggle: {
    marginRight: 10,
  },
  tabsGroup: {
    width: 256,
    height: 42,
    padding: 4,
    borderRadius: 3,
    background: '#FFFFFF',
    border: 'none',
    boxSizing: 'border-box',
    minHeight: 'unset',
    '& .MuiTabs-flexContainer': {
      gap: 4,
    },
    '& .MuiTab-root.small': {
      minWidth: 122,
      maxWidth: 122,
      height: 32,
      padding: '5px 0',
      borderRadius: 3,
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '22px',
      textTransform: 'none',
    },
    '& .MuiTab-root.small .MuiTab-wrapper': {
      width: '100%',
      padding: 0,
      color: '#757575',
    },
    '& .MuiTab-root.small.Mui-selected': {
      background: '#1B3963',
      color: '#FFFFFF',
    },
    '& .MuiTab-root.small.Mui-selected .MuiTab-wrapper': {
      color: '#FFFFFF',
    },
  },
  toolTip: {
    color: '#8D9CB1',
    width: 16,
    height: 16,
    fontSize: 16,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 5,
  },
  headerTitle: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '28px',
    color: '#181818',
  },
  subTitle: {
    marginLeft: 5,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 26,
    color: '#5E5E5E',
  },
  tabsLabel: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    color: '#474747',
    paddingRight: '16px',
  },
  spinnerContainer: {
    width: '100%',
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  portfolioListContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#1B3963',
    width: 150,
    height: 40,
    borderRadius: 3,
    marginLeft: 12,
    cursor: 'pointer',
  },
  portfolioListTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 600,
    color: '#FFFFFF',
    marginLeft: 8,
  },
  FormatListBulletedIcon: {
    color: 'white',
    width: 22,
  },
})

const getToggleValue = (pathname: string) => {
  switch (pathname) {
    case HOME_PATHNAME:
      return 0
      break
    case PORTFOLIO_HOME_PATHNAME:
      return 0
      break
    case PORTFOLIO_SINGLE_PATHNAME:
      return 0
      break
    case PORTFOLIO_LAST_WEEK_PATHNAME:
      return 1
      break
    default:
      return 0
  }
}

const PortfolioPage = (props: any) => {
  const history = useHistory()
  const classes = useStyles()
  const {
    state,
    getTickersOnlyInPortfolio,
    getAllTickersInUniverse,
    changeSelectedTab,
    changeSelectedRiskTab,
    cleanUp,
  } = useContext(PortfolioContext)
  const [selectedTab, setSelectedTab] = useState(state.selectedTab)
  const [selectedRiskTypeTab, setSelectedRiskTypeTab] = useState(
    state.selectedRiskTypeTab,
  )
  const [recent, setRecent] = useState<any>([])
  // const companies = useMemo(() => [...recent, ...companySearchList], [
  //   recent,
  //   companySearchList,
  // ])
  const [openTooltip, setOpenTooltip] = React.useState(false)
  const handleClickOpenTooltip = () => {
    setOpenTooltip(true)
  }

  const getAllTickersInUniverses = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInUniverse ||
        (Array.isArray(state?.tickersInUniverse) &&
          state?.tickersInUniverse.length === 0)
      ) {
        getAllTickersInUniverse(userId)
      }
    },
    [state?.tickersInUniverse],
  )
  const getTickersOnlyInPortfolios = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInPortfolio ||
        (Array.isArray(state?.tickersInPortfolio) &&
          state?.tickersInPortfolio.length === 0)
      ) {
        getTickersOnlyInPortfolio(userId)
      }
    },
    [state?.tickersInPortfolio],
  )

  useEffect(() => {
    clearD3Tips()
    cleanUp()
    if (!getCookie('userId') && getCookie('accessToken')) {
      userService
        .getUser(getCookie('email'))
        .then(res => {
          setCookieHelper('userId', res.data, EXPIRED_SECOND)
          setCookieHelper(
            'implied_rating_flag',
            res.implied_rating_flag,
            EXPIRED_SECOND,
          )
          const analysisFlag = res.analysis_flag ?? res?.data?.analysis_flag
          if (analysisFlag !== undefined && analysisFlag !== null) {
            setCookieHelper('analysis_flag', analysisFlag, EXPIRED_SECOND)
          }
          getTickersOnlyInPortfolios(res.data)
          getAllTickersInUniverses(res.data)
        })
        .catch(() => {})
    } else {
      getTickersOnlyInPortfolios(getCookie('userId'))
      getAllTickersInUniverses(getCookie('userId'))
    }
  }, [])

  useEffect(() => {
    setSelectedTab(getToggleValue(props.location.pathname))
    changeSelectedTab(getToggleValue(props.location.pathname))
  }, [props.location.pathname])

  const changeTabView = (event: React.ChangeEvent<{}>, newValue?: any) => {
    setSelectedTab(newValue)
    changeSelectedTab(newValue)
    if (newValue === 0) history.push(PORTFOLIO_HOME_PATHNAME)
    else if (newValue === 1) history.push(PORTFOLIO_LAST_WEEK_PATHNAME)
  }

  const changeRiskTypeTabView = (
    event: React.ChangeEvent<{}>,
    newValue?: any,
  ) => {
    setSelectedRiskTypeTab(newValue)
    changeSelectedRiskTab(newValue)
  }

  return (
    <>
      <div className={classes.container}>
        <PortfolioTooltipModal
          open={openTooltip}
          handleClose={() => {
            setOpenTooltip(false)
          }}
        />
        <div className={classes.frame}>
          <div className={classes.frameHeader}>
            <div>
              <span className={classes.headerTitle}>Portfolio</span>
              <span className={classes.subTitle}>
                (Heat-Map of Risk in your Portfolio Companies)
              </span>
              <HelpRounded
                className={classes.toolTip}
                key="1"
                onClick={() => handleClickOpenTooltip()}
              />
            </div>
            <div className={classes.tabsContainer}>
              {/* {state.creditRiskDataExisted && (
                <div className={classes.riskToggle}>
                  <BFTabs
                    size="small"
                    value={selectedRiskTypeTab}
                    onChange={changeRiskTypeTabView}
                  >
                    <BFTab
                      size="small"
                      label="Risk Outlook"
                      value={RISK_TYPE.EQUITY}
                    />
                  </BFTabs>
                </div>
              )} */}
              <BFTabs
                size="small"
                value={selectedTab}
                onChange={changeTabView}
                className={classes.tabsGroup}
              >
                <BFTab size="small" label="Today" value={0} />
                <BFTab size="small" label="Week to Date" value={1} />
              </BFTabs>
            </div>
          </div>
          <div className={classes.frameBody}>
            {state.loading && (
              <div className={classes.portfolioTable}>
                <ResponsiveArticle />
              </div>
            )}
            {!state.loading && (
              <div>
                {selectedTab === 0 ? (
                  <PortfolioTodayCompanyPage
                    tickers={state.tickersInPortfolio}
                    riskType={selectedRiskTypeTab}
                    tickerId={null}
                  />
                ) : (
                  <PortfolioLastWeek
                    tickers={state.tickersInPortfolio}
                    riskType={selectedRiskTypeTab}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default PortfolioPage
